"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IDataDestination.js.map